(function () {
  'use strict';

  var managerKey = '__ksProductSectionManager';
  var rootSelector = '[data-ks-product-section], .ks-page';
  var gallerySelectors = {
    stage: '[data-ks-gallery-stage], #ks-stage',
    image: '[data-ks-gallery-image], .ks-gallery-image, #ks-galImg',
    video: '[data-ks-gallery-video], .ks-gallery-video, #ks-galVid',
    thumbs: '[data-ks-gallery-thumbnails], [data-ks-gallery-thumbs], #ks-thumbs',
    thumb: '[data-ks-gallery-thumb], button'
  };
  var existingManager = window[managerKey];

  if (existingManager && typeof existingManager.initialize === 'function') {
    existingManager.initialize(document);
    clearTimeout(window.__ksProductRevealFallback);
    document.documentElement.classList.add('ks-js');
    return;
  }

  var states = new Map();
  var frameId = null;
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var supportsObserver = 'IntersectionObserver' in window;

  function closestRoot(element) {
    return element && element.closest ? element.closest(rootSelector) : null;
  }

  function isOwnedBy(element, root) {
    return closestRoot(element) === root;
  }

  function findOwned(root, selector) {
    var matches = root.querySelectorAll(selector);
    var index;

    for (index = 0; index < matches.length; index += 1) {
      if (isOwnedBy(matches[index], root)) {
        return matches[index];
      }
    }

    return null;
  }

  function findAllOwned(root, selector) {
    return Array.prototype.filter.call(root.querySelectorAll(selector), function (element) {
      return isOwnedBy(element, root);
    });
  }

  function collectRoots(scope) {
    var searchRoot = scope || document;
    var roots = [];

    if (searchRoot.matches && searchRoot.matches(rootSelector)) {
      roots.push(searchRoot);
    }

    if (searchRoot.querySelectorAll) {
      Array.prototype.forEach.call(searchRoot.querySelectorAll(rootSelector), function (root) {
        if (roots.indexOf(root) === -1) {
          roots.push(root);
        }
      });
    }

    return roots;
  }

  function dataValue(element, names) {
    var index;
    var value;

    for (index = 0; index < names.length; index += 1) {
      value = element.getAttribute(names[index]);
      if (value !== null && value !== '') {
        return value;
      }
    }

    return '';
  }

  function setGallery(root, state) {
    var stage = findOwned(root, gallerySelectors.stage);
    var image = findOwned(root, gallerySelectors.image);
    var video = findOwned(root, gallerySelectors.video);
    var thumbs = findOwned(root, gallerySelectors.thumbs);

    if (!stage || !image || !thumbs) {
      return;
    }

    function showImage(button) {
      var source = dataValue(button, ['data-ks-media-src', 'data-media-src', 'data-src']);
      var sourceSet = dataValue(button, ['data-ks-media-srcset', 'data-media-srcset']);
      var thumbnail = button.querySelector('img');
      // An empty alt deliberately marks a decorative image. Keep it distinct
      // from a missing attribute, and never substitute the button's action name.
      var alt = button.getAttribute('data-ks-media-alt');
      if (alt === null) alt = button.getAttribute('data-media-alt');
      if (alt === null) alt = thumbnail ? thumbnail.alt : '';

      if (video) {
        video.pause();
        video.hidden = true;
        video.style.display = 'none';
      }

      stage.classList.remove('ks-vidmode');
      image.hidden = false;
      image.style.display = 'block';

      if (source) {
        image.src = source;
        if (!sourceSet) {
          image.removeAttribute('srcset');
        }
      }

      if (sourceSet) {
        image.srcset = sourceSet;
      }

      image.alt = alt;
    }

    function showVideo() {
      var playPromise;

      if (!video) {
        return false;
      }

      image.hidden = true;
      image.style.display = 'none';
      stage.classList.add('ks-vidmode');
      video.hidden = false;
      video.style.display = 'block';
      playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }

      return true;
    }

    function handleThumbnailClick(event) {
      var target = event.target;
      var button = target && target.closest ? target.closest(gallerySelectors.thumb) : null;
      var mediaType;
      var didChange = true;

      if (!button || !thumbs.contains(button) || !isOwnedBy(button, root)) {
        return;
      }

      mediaType = dataValue(button, ['data-ks-media-type', 'data-media-type', 'data-type']).toLowerCase();

      if (mediaType === 'video' || mediaType === 'vid') {
        didChange = showVideo();
      } else {
        showImage(button);
      }

      if (!didChange) {
        return;
      }

      Array.prototype.filter.call(thumbs.querySelectorAll(gallerySelectors.thumb), function (thumb) {
        return isOwnedBy(thumb, root);
      }).forEach(function (thumb) {
        thumb.setAttribute('aria-current', thumb === button ? 'true' : 'false');
      });
    }

    thumbs.addEventListener('click', handleThumbnailClick);
    state.cleanups.push(function () {
      thumbs.removeEventListener('click', handleThumbnailClick);
    });
  }

  function setReveals(root, state) {
    var revealItems = findAllOwned(root, '.ks-rv');

    if (state.reducedMotion || !supportsObserver) {
      revealItems.forEach(function (item) {
        item.classList.add('ks-in');
      });
      return;
    }

    state.revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('ks-in');
        state.revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -60px 0px'
    });

    revealItems.forEach(function (item) {
      state.revealObserver.observe(item);
    });
  }

  function setScrollProgress(root, state) {
    var marks = findAllOwned(root, '.ks-bloom, .ks-rise, .ks-rise-cap');

    state.marks = marks;

    if (!marks.length) {
      return;
    }

    if (state.reducedMotion || !supportsObserver) {
      marks.forEach(function (mark) {
        mark.style.setProperty('--p', 1);
      });
      return;
    }

    marks.forEach(function (mark) {
      mark.style.removeProperty('--p');
    });

    state.progressObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          state.activeMarks.add(entry.target);
        } else {
          state.activeMarks.delete(entry.target);
        }
      });

      queuePaint();
    }, {
      rootMargin: '20% 0px 20% 0px'
    });

    marks.forEach(function (mark) {
      state.progressObserver.observe(mark);
    });
  }

  function setMotionPreference(root, reducedMotion) {
    findAllOwned(root, 'video').forEach(function (video) {
      if (reducedMotion) {
        if (video.hasAttribute('autoplay')) {
          video.setAttribute('data-ks-motion-autoplay', 'true');
          video.removeAttribute('autoplay');
        }
        video.pause();
      } else if (video.getAttribute('data-ks-motion-autoplay') === 'true') {
        video.setAttribute('autoplay', '');
        video.removeAttribute('data-ks-motion-autoplay');
      }
    });
  }

  function ease(value) {
    return 1 - Math.pow(1 - value, 3);
  }

  function paint() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    frameId = null;
    states.forEach(function (state, root) {
      if (!root.isConnected) {
        destroyRoot(root);
        return;
      }

      state.activeMarks.forEach(function (mark) {
        var rect;
        var midpoint;
        var rawProgress;
        var stagger;
        var progress;

        if (!mark.isConnected) {
          state.activeMarks.delete(mark);
          return;
        }

        rect = mark.getBoundingClientRect();
        midpoint = rect.top + rect.height / 2;
        rawProgress = (viewportHeight - midpoint) / (viewportHeight * 0.7);
        stagger = (parseFloat(dataValue(mark, ['data-ks-stagger', 'data-stagger'])) || 0) * 0.26;
        progress = (rawProgress - stagger) / (1 - stagger);
        progress = Math.max(0, Math.min(1, progress));
        mark.style.setProperty('--p', ease(progress).toFixed(4));
      });
    });
  }

  function queuePaint() {
    if (frameId !== null) {
      return;
    }

    frameId = window.requestAnimationFrame(paint);
  }

  function initializeRoot(root) {
    var state;

    if (!root || states.has(root)) {
      return;
    }

    state = {
      activeMarks: new Set(),
      cleanups: [],
      marks: [],
      progressObserver: null,
      reducedMotion: motionQuery ? motionQuery.matches : false,
      revealObserver: null
    };

    states.set(root, state);
    root.setAttribute('data-ks-initialized', 'true');
    setGallery(root, state);
    setReveals(root, state);
    setScrollProgress(root, state);
    setMotionPreference(root, state.reducedMotion);
  }

  function destroyRoot(root) {
    var state = states.get(root);

    if (!state) {
      return;
    }

    if (state.revealObserver) {
      state.revealObserver.disconnect();
    }

    if (state.progressObserver) {
      state.progressObserver.disconnect();
    }

    state.cleanups.forEach(function (cleanup) {
      cleanup();
    });
    state.activeMarks.clear();
    root.removeAttribute('data-ks-initialized');
    states.delete(root);
  }

  function initialize(scope) {
    collectRoots(scope).forEach(initializeRoot);
    queuePaint();
  }

  function destroy(scope) {
    collectRoots(scope).forEach(destroyRoot);
  }

  function refreshMotionPreference() {
    var roots = Array.from(states.keys());

    roots.forEach(destroyRoot);
    roots.forEach(initializeRoot);
    queuePaint();
  }

  function handleSectionLoad(event) {
    initialize(event.target);
  }

  function handleSectionUnload(event) {
    destroy(event.target);
  }

  window.addEventListener('scroll', queuePaint, { passive: true });
  window.addEventListener('resize', queuePaint);
  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);

  if (motionQuery) {
    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', refreshMotionPreference);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(refreshMotionPreference);
    }
  }

  window[managerKey] = {
    destroy: destroy,
    initialize: initialize
  };

  initialize(document);
  clearTimeout(window.__ksProductRevealFallback);
  document.documentElement.classList.add('ks-js');
})();
